document.addEventListener("DOMContentLoaded", function() {
  function initMobileSlider() {
    if (window.innerWidth <= 768) {
      if (!$('.multicolumn-slider').hasClass('slick-initialized')) {
        $('.multicolumn-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
           prevArrow: $('.custom-prev-2'),
           nextArrow: $('.custom-next-2'),
          autoplay: false,
          infinite: true,
          speed: 1000,
          adaptiveHeight: false
        });
      }
    } else {
      if ($('.multicolumn-slider').hasClass('slick-initialized')) {
        $('.multicolumn-slider').slick('unslick');
      }
    }
  }

  initMobileSlider();

  window.addEventListener('resize', function() {
    initMobileSlider();
  });
});

// B2B wholesale "Tester" button: adds the linked tester variant (qty 1) straight
// to cart, independent of the main product form / quantity selector.
document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-tester-add]');
  if (!button || button.disabled) return;

  event.preventDefault();

  var variantId = button.dataset.variantId;
  if (!variantId || typeof Theme === 'undefined' || !Theme.routes) return;

  var sectionIds = [];
  document.querySelectorAll('cart-items-component').forEach(function (item) {
    if (item.dataset.sectionId) sectionIds.push(item.dataset.sectionId);
  });

  button.disabled = true;
  var buttonText = button.querySelector('.tester-add-option__button-text');
  var originalText = buttonText ? buttonText.textContent : null;

  fetch(Theme.routes.cart_add_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      id: Number(variantId),
      quantity: 1,
      sections: sectionIds.join(','),
    }),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      if (data.status) {
        console.error('Tester add to cart failed:', data.message);
        button.disabled = false;
        return;
      }

      if (buttonText) {
        buttonText.textContent = button.dataset.addedText || buttonText.textContent;
      }

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: data,
            sourceId: 'tester-add-button',
            data: {
              source: 'tester-add-button',
              itemCount: 1,
              sections: data.sections,
            },
          },
        })
      );

      setTimeout(function () {
        button.disabled = false;
        if (buttonText && originalText) buttonText.textContent = originalText;
      }, 2000);
    })
    .catch(function (error) {
      console.error('Tester add to cart error:', error);
      button.disabled = false;
    });
});
